import { useSyncExternalStore } from 'react';

/** A short message at the bottom of the screen (`Toasts` shows them): at most three at a time. */
export interface ToastItem {
  id: number;
  text: string;
}

let items: ToastItem[] = [];
let next = 1;
const listeners = new Set<() => void>();

function emit() {
  for (const l of listeners) l();
}

/** Shows `text` for `ms` milliseconds. */
export function toast(text: string, ms = 2600) {
  const id = next++;
  items = [...items.slice(-2), { id, text }];
  emit();
  setTimeout(() => {
    items = items.filter((t) => t.id !== id);
    emit();
  }, ms);
}

function subscribe(l: () => void) {
  listeners.add(l);
  return () => listeners.delete(l);
}

const snapshot = () => items;

/** The toasts on screen now. */
export function useToastList(): ToastItem[] {
  return useSyncExternalStore(subscribe, snapshot, snapshot);
}
